
/* injects from baggage-loader */

'use strict';

import sellerCashierSearchDirective from './sellerCashierSearch.directive';
import sellerCashierSearchConstant from './sellerCashierSearch.constant';
/**
 * SellerCashierSearch module definition.
 */
const sellerCashierSearchModule = angular.module('sellerCashierSearch.module', []);

sellerCashierSearchModule.directive('sellerCashierSearch', sellerCashierSearchDirective);
sellerCashierSearchModule.constant('sellerCashierSearchConstant', sellerCashierSearchConstant);

export default sellerCashierSearchModule;



// WEBPACK FOOTER //
// ./src/app/core/components/sellerCashierSearch/sellerCashierSearch.module.js